import React from 'react'

interface BusinessSkeletonProps {
    itemsCount?: number
}

const BusinessSkeleton: React.FC<BusinessSkeletonProps> = ({
    itemsCount = 3,
}) => {
    return (
        <div className="animate-pulse">
            {/* Header Skeleton */}
            <div className="h-6 bg-gray-200 rounded w-32 mb-4"></div>

            <div className="max-h-[400px] overflow-hidden">
                <div className="space-y-4">
                    {/* Hôm nay Section */}
                    <div>
                        {/* Section Title */}
                        <div className="h-4 bg-gray-200 rounded w-16 mb-3"></div>

                        {/* Business Items */}
                        <div className="space-y-1">
                            {Array.from({ length: itemsCount }).map(
                                (_, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center bg-gray-50 rounded-lg px-4 py-2"
                                    >
                                        <div className="flex-1">
                                            <div className="flex items-center justify-between">
                                                <div className="flex-1">
                                                    {/* Number + Name */}
                                                    <div className="flex items-center mb-2">
                                                        <div className="w-4 h-4 bg-gray-200 rounded mr-2"></div>
                                                        <div className="h-4 bg-gray-200 rounded w-24"></div>
                                                    </div>
                                                    {/* Department */}
                                                    <div className="ps-4">
                                                        <div className="h-3 bg-gray-200 rounded w-16"></div>
                                                    </div>
                                                </div>
                                                {/* Status */}
                                                <div className="h-5 bg-gray-200 rounded w-12"></div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    </div>

                    {/* Ngày mai Section */}
                    <div>
                        {/* Section Title */}
                        <div className="h-4 bg-gray-200 rounded w-16 mb-3 pt-3"></div>

                        {/* Business Items */}
                        <div className="space-y-1">
                            {Array.from({
                                length: Math.max(1, itemsCount - 1),
                            }).map((_, index) => (
                                <div
                                    key={index}
                                    className="flex items-center bg-gray-50 rounded-lg px-4 py-2"
                                >
                                    <div className="flex-1">
                                        <div className="flex items-center justify-between">
                                            <div className="flex-1">
                                                {/* Number + Name */}
                                                <div className="flex items-center mb-2">
                                                    <div className="w-4 h-4 bg-gray-200 rounded mr-2"></div>
                                                    <div className="h-4 bg-gray-200 rounded w-28"></div>
                                                </div>
                                                {/* Department */}
                                                <div className="ps-4">
                                                    <div className="h-3 bg-gray-200 rounded w-20"></div>
                                                </div>
                                            </div>
                                            {/* Status */}
                                            <div className="h-5 bg-gray-200 rounded w-14"></div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* View All Button Skeleton */}
            <div className="mt-4 pt-3">
                <div className="h-8 bg-gray-200 rounded w-full"></div>
            </div>
        </div>
    )
}

export default BusinessSkeleton
